import { Card, Title, Text, LoadingOverlay, Box, Flex } from '@mantine/core';
import { useFetch } from '@mantine/hooks';
import { ICourse } from '../../../interfaces/ICourse';
import { CourseCard } from './CourseCard';

export function PurchasedCourses() {
  const { data, loading } = useFetch<{ data: ICourse[] }>(
    `${import.meta.env.VITE_API_URL}/services/userCourses`,
    {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );

  const purchasedCourses = data?.data?.filter(course => course.unlocked) || [];

  return (
    <Card shadow='sm' withBorder p='sm' radius='sm'>
      <Title order={4} mb='sm'>
        Corsi Acquistati
      </Title>
      <LoadingOverlay visible={loading} />
      <Box style={{ overflowX: 'scroll' }} pb={20}>
        {purchasedCourses.length > 0 ? (
          <Flex gap='sm' wrap='nowrap' p={5}>
            {purchasedCourses.map(course => (
              <CourseCard key={course.id} course={course} />
            ))}
          </Flex>
        ) : (
          <Text c='dimmed' ta='center'>
            Nessun corso acquistato
          </Text>
        )}
      </Box>
    </Card>
  );
}
